import { css, Interpolation, Theme } from '@emotion/react'

export const title: Interpolation<Theme> = (theme) => css`
  margin-bottom: ${theme.spacing(0.75)};

  color: ${theme.colors.white};
  font-size: 16px;
  font-weight: 500;
`

export const purchases: Interpolation<Theme> = (theme) => css`
  margin-top: ${theme.spacing(0.75)};
`

export const purchaseTitle: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.white};
  font-size: 14px;
  line-height: 22px;
`
